import api from '@app/api'

import type { AblePaginatedResponseFn, ResponseDto } from '@app/api/dtos'
import type { TemplateDto } from './dtos'

import type { DeleteTemplatesItemData, PatchTemplatesItemData, PostTemplatesItemData } from './types'
import type { DefaultParams } from '@app/api/types'

const URL = '/monitoring-tasks/comment-samples/'

export const getTemplates: AblePaginatedResponseFn<DefaultParams, TemplateDto> = async params => {
  const response = await api.get(URL, { params })
  return response.data
}

export const deleteTemplates = async (data: DeleteTemplatesItemData): Promise<void> => {
  await api.delete<ResponseDto<TemplateDto>>(URL, { data })
}

export const patchTemplatesItem = async (params: PatchTemplatesItemData): Promise<void> => {
  const { id, ...data } = params

  await api.patch<ResponseDto<TemplateDto>>(`${URL}${id}/`, data)
}

export const postTemplatesItem = async (data: PostTemplatesItemData): Promise<void> => {
  await api.post<ResponseDto<TemplateDto>>(`${URL}`, data)
}
